export const UNLOCK_SUCCESS_TEXT = 'unlock.success.text';
export const UNLOCK_FAILURE_TEXT = 'unlock.failure.text';
export const UNLOCK_SUBMIT_TEXT = 'unlock.submit.text';
export const UNLOCK_DAYS_REMAINING = 'unlock.days.remaining.text';
export const UNLOCK_HOURS_REMAINING = 'unlock.hours.remaining.text';
export const UNLOCK_MINUTES_REMAINING = 'unlock.minutes.remaining.text';
